import React, { useState, useEffect, Fragment } from 'react';
import tools from "../../components/tools/tools";
// import './assets/css/bootstrap.min.css';
import './assets/css/signin.css';

const Login = () => {
  const [server, setServer] = useState('');

    function iniciarSesion(){
        let btn = document.getElementById('btnSesion')
        btn.disabled = true
        let usuario = document.getElementById('inputUsuario').value
        let contra = document.getElementById('inputContrasena').value

        let data = {
            usuario: usuario,
            contra: contra
        }

        if(data.usuario == '' || data.contra == ''){
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning',
                text: `Es necesario llenar todos los campos para continuar`,
                time: 3,
                position: 'top'
            })
        }

        fetch('/rt_login', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then((response) => {
            console.log(response)
            if(response.estatus == 1){
                btn.disabled = false
                return tools.notie.alert({
                    type: 'warning',
                    text: `No fue posible encontrar el usuario ingresado`,
                    time: 3,
                    position: 'top'
                })
            }
            if(response.estatus == 2){
                btn.disabled = false
                return tools.notie.alert({
                    type: 'warning',
                    text: `La contraseña ingresada es incorrecta`,
                    time: 3,
                    position: 'top'
                })
            }
            tools.notie.alert({
                type: 'success',
                text: `Credenciales válidas, redireccionando...`,
                time: 3,
                position: 'top'
            })
            setTimeout(() => {
                window.location.replace(response.location)
            }, 2500);
        })
        .catch((error) => {
            console.log(error)
            btn.disabled = false
            return tools.notie.alert({
                type: 'warning',
                text: `Ha ocurrido un error al intentar iniciar la sesión.`,
                time: 3,
                position: 'top'
            })
        })

    }

    useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "/assets/css/bootstrap.min.css"; // Asegúrate de que la ruta sea correcta
        document.head.appendChild(link);
        
        return () => {
          document.head.removeChild(link); // Se elimina Bootstrap al desmontar el componente
        };
    }, []);

    useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "/assets/css/signin.css"; // Asegúrate de que la ruta sea correcta
        document.head.appendChild(link);
    
        return () => {
          document.head.removeChild(link); // Se elimina Bootstrap al desmontar el componente
        };
    }, []);

  return (
    <Fragment>
        <div className='divContainer text-center'>
            <form className='form-signin'>
                <img className='mb-4' src={require('./assets/img/logo-addex.png')} alt='' style={{width: '80%'}}/>
                <h1 className='h3 mb-3 font-weight-normal'>Mesa de registro</h1>
                <label className='mb-2'>Ingresa tus credenciales para continuar</label>
                <div className='row mb-3'>
                    <input type='text' id='inputUsuario' name='inputUsuario' className='form-control' placeholder='Usuario'/>
                </div>
                <div className='row'>
                    <input type='password' id='inputContrasena' name='inputContrasena' className='form-control' placeholder='Contraseña'/>
                </div>
                <br></br>
                <div className='row'>
                    <button className='btn btn-lg btn-primary btn-block' id='btnSesion' type='submit' onClick={() => {iniciarSesion()}}>Iniciar sesión</button>
                </div>
            </form>
        </div>
    </Fragment>
  );
};

export default Login;